import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Select from 'react-select';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function EditAnggota() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState([{
    name_anggota: "",
    npp_anggota: "",
    username: "",
    email: "",
    idkopkar:"",
    status:"",
    spn:"",
    role_id:"",
  }]);
  const [listStatusKopkar, setListStatusKopkar] = useState([
    { label: "1 - Aktif", value: 1 },
    { label: "0 - Tidak Aktif", value: 0 },
  ]);
  const [listStatusSPN, setListStatusSPN] = useState([
    { label: "1 - Aktif", value: 1 },
    { label: "0 - Tidak Aktif", value: 0 },
  ]);
  const [listRole, setListRole] = useState([]);

  const [dataAnggota, setDataAnggota] = useState([]);
  const [statusKopkar, setStatusKopkar] = useState([]);
  const [statusSPN, setStatusSPN] = useState([]);
  const [roleAnggota, setRoleAnggota] = useState([]);


  // CONTROLLER

  const fetchEditAnggota = async () => {
    setIsLoading(true);
    await axios
      .all(
        [
         baseAPI .get(`/v1/user/${id}`, {headers: { Authorization: `Bearer ${token}` } }),
         baseAPI .get(`/v1/role`, {headers: { Authorization: `Bearer ${token}` } }),
      ]
      )
      .then((res) => {
        const data = res[0].data.data.userData;
        const dataRole = res[1].data.data;

        let statKopkar = [];
        listStatusKopkar.forEach(e => {
          if (e.value == data[0].status) {
            statKopkar.push({ label: e.label, value: e.value })
          }
        });

        let statSPN = [];
        listStatusSPN.forEach(e => {
          if (e.value == data[0].spn) {
            statSPN.push({ label: e.label, value: e.value })
          }
        });
        
        let role = [];
        dataRole.forEach(e => {
          if (e.id == data[0].role_id) {
            role.push({ label: e.id + " - " + e.role_name, value: e.id })
          }
        });

        let roles = [];
        dataRole.forEach(e => {
          roles.push({ label: e.id + " - " + e.role_name, value: e.id })
        });

        setStatusKopkar(statKopkar);
        setStatusSPN(statSPN);
        setListRole(roles);
        setRoleAnggota(role);
        setDataAnggota(data[0]);
        setNewData([{
          name_anggota: data[0].name_anggota,
          npp_anggota: data[0].npp_anggota,
          username: data[0].username,
          idkopkar: data[0].idkopkar,
          status: data[0].status,
          spn: data[0].spn,
          role_id: data[0].role_id,
        }])
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updateUser = async (id, status) => {
    
    Swal.fire({
      title: status === "Update" ? 'Do you want to update the data?' : 'Do you want to reset password this member?',
      showDenyButton: status === "Update" ? true : false,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(newData));
        body.append('status', status);
        
        baseAPI
          .put(`/v1/user/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: status === "Update" ? "User data has been updated." : "Password user has been reset.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed update the data.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchEditAnggota();
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });

  };


  useEffect(() => {
    setIsLoading(true);
    if (user.role === ADMIN) {
      fetchEditAnggota();
    }
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Anggota</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Edit Anggota</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Edit Data Anggota</b></p>
              </div>

              {/* Username/NPP */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  NPP / Username
                </label>
                <input
                  defaultValue={dataAnggota.npp_anggota}
                  placeholder='NPP untuk username anda'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], npp_anggota: e.target.value, username: e.target.value}])}
                />
              </div>

              {/* Name */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama
                </label>
                <input
                  defaultValue={dataAnggota.name_anggota}
                  placeholder='Nama anda'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], name_anggota: e.target.value}])}
                />
              </div>

              {/* Email */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Email
                </label>
                <input
                  defaultValue={dataAnggota.email}
                  placeholder='Email aktif anda'
                  className="form-control"
                  onChange={e => setNewData([{...newData[0], email: e.target.value}])}
                />
              </div>

              {/* ID Kopkar */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  ID Kopkar
                </label>
                <input
                  readOnly
                  defaultValue={dataAnggota.idkopkar}
                  placeholder='ID Kopkar'
                  className="form-control"
                />
              </div>

              {/* Status Anggota Kopkar */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Status Anggota Kopkar
                </label>
                <Select
                  options={listStatusKopkar}
                  value={statusKopkar}
                  placeholder="Pilih status kopkar"
                  onChange={e => {
                    setStatusKopkar([{label: e.label, value: e.value}])
                    setNewData([{...newData[0], status: e.value}]);
                  }}
                />
              </div>

              {/* Status Anggota SPN */}
              <div className='col-md-4 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Status Anggota SPN
                </label>
                <Select
                  options={listStatusSPN}
                  value={statusSPN}
                  placeholder="Pilih status spn"
                  onChange={e => {
                    setStatusSPN([{label: e.label, value: e.value}])
                    setNewData([{...newData[0], spn: e.value}]);
                  }}
                />
              </div>

              {/* Role Anggota */}
              <div className='col-md-12 mb-4'>
                <label htmlFor='true' className='form-label'>
                  Role Anggota
                </label>
                <Select
                  options={listRole}
                  value={roleAnggota}
                  placeholder="Pilih role anggota"
                  onChange={e => {
                    setRoleAnggota([{label: e.label, value: e.value}])
                    setNewData([{...newData[0], role_id: e.value}]);
                  }}
                />
              </div>

              <div className='col-md-6'>
                <button
                  disabled={newData[0].name_anggota !== "" && newData[0].npp_anggota !== "" && newData[0].email !== "" ? false : true}
                  type="button"
                  className='btn btn-success col-md-12'
                  style={{backgroundColor: '#6A9C89'}}
                  onClick={() => updateUser(id, "Update")}
                >
                  Save
                </button>
              </div>

              <div className='col-md-6'>
                <button
                  disabled={newData[0].email !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updateUser(id, "Reset Password")}
                >
                  Reset Password
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default EditAnggota;